export default {
  // 设置/获取当前ssoToken
  setCurrentUserToken: function (ssoToken) {
    window.localStorage.setItem('currentUser_token', ssoToken)
    return new Promise()
  },
  getCurrentUserToken: function () {
    let token = window.localStorage.getItem('currentUser_token')
    if (!token) {
      token = window.localStorage.getItem('thirdPartyUserToken')
    }
    return token
  },
  // 设置/获取当前companyId
  setCurrentUserCompanyId: function (companyId) {
    window.localStorage.setItem('currentUser_companyId', companyId)

    return new Promise()
  },
  getCurrentUserCompanyId: function () {
    let companyId = window.localStorage.getItem('currentUser_companyId')
    if (!companyId) {
      companyId = window.localStorage.getItem('thirdParty_companyId')
    }
    return companyId
  },
  // 设置/获取订单确认信息
  setOrderConfirmInfo: function (orderObj) {
    if (orderObj) {
      window.localStorage.setItem('orderObj', JSON.stringify(orderObj))
    }
  },
  getOrderConfirmInfo: function () {
    let orderObj = JSON.parse(window.localStorage.getItem('orderObj'))
    return orderObj
  },
  removeOrderConfirmInfo: function () {
    window.localStorage.removeItem('orderObj')
  }
}
